module.exports = {
  context: {
    featuredStories: '@featured-stories'
  }
}
